import * as React from 'react'
import Button from '@mui/material/Button'
import TextField from '@mui/material/TextField'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import styled from 'styled-components'
import { useState, useEffect } from 'react'
import axios from 'axios'
import Swal from 'sweetalert2'
import { useSelector } from 'react-redux'

export default function DentalDialog(props) {
    const token = localStorage.getItem('token')
    const url = process.env.REACT_APP_APP_URL
    // const url = 'http://192.168.1.15:9000/api/'
    const api = axios.create({
        baseURL: url,
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
        }
    })

    const [code, setCode] = useState('')
    const [name, setName] = useState('')
    const [bodyParts, setBodyParts] = useState('')

    const [description, setDescription] = useState('')

    const TreatmentCreate = () => {
        const data = {
            name: name,
            code: code,
            bodyParts: bodyParts,
            description: description
        }

        //  alert(JSON.stringify(data))

        // console.log(data)
        const config = {
            headers: { 'Content-Type': 'application/json' }
        }
        api.post('dental-treatment-list', data, config).then(function (response) {
            Swal.fire({
                title: 'Successful!',
                text: 'You Created Income Data!',
                icon: 'success',
                // showCancelButton: true,

                cancelButtonText: 'Close'
            })
            window.location.reload()

            // props.setTreatmentLists([...props.treatmentLists, response.data.list[0]])
        })
        props.close()
    }

    return (
        <div>
            <Dialog open={props.open} onClose={props.close} fullWidth maxWidth='md'>
                <DialogTitle>
                    {' '}
                    <div className='modal-header ok'>
                        <h4 className='modal-title'>Create Dental Treatment</h4>
                        <button
                            type='button'
                            className='close'
                            data-dismiss='modal'
                            aria-label='Close'
                            onClick={props.close}
                        >
                            <span aria-hidden='true'>&times;</span>
                        </button>
                    </div>
                </DialogTitle>
                <DialogContent>
                    <DialogContentText></DialogContentText>

                    <div class='modal-body'>
                        <div class='form-group'>
                            <label for='name'>Code</label>
                            <input
                                type='text'
                                class='form-control border border-info'
                                name='code'
                                onChange={e => setCode(e.target.value)}
                            />
                        </div>
                        <div class='form-group'>
                            <label for='name'>Name</label>
                            <input
                                type='text'
                                class='form-control border border-info'
                                name='name'
                                placeholder='eg. mg mg'
                                onChange={e => setName(e.target.value)}
                            />
                        </div>
                        <div class='form-group'>
                            <label for='name'>Choose Body Parts</label>
                            <select
                                name='currency'
                                id=''
                                className='form-control mt-1'
                                onchange='convert(this.value)'
                                onChange={e => setBodyParts(e.target.value)}
                            >
                                <option hidden>Choose Body Parts</option>

                                {/* <option value='Face'>Face</option>
                                <option value='Body'>Body</option>
                                <option value='Body Injection'>Body Injection</option> */}
                                <option value='Tooth'>Tooth</option>
                            </select>
                        </div>
                        <div class='form-group'>
                            <label for='name'>Description</label>
                            <textarea
                                className='form-control'
                                id='description'
                                onChange={e => setDescription(e.target.value)}
                            ></textarea>
                        </div>
                    </div>
                    <div class='modal-footer'>
                        <Button
                            class='btn btn-secondary'
                            data-dismiss='modal'
                            onClick={props.close}
                        >
                            Close
                        </Button>
                        <Button onClick={TreatmentCreate} class='btn btn-primary'>
                            Save
                        </Button>
                    </div>
                </DialogContent>
            </Dialog>
        </div>
    )
}
// phyo
//maymyat
